import React, { useState, useEffect } from "react";
import axios from "axios";

import { BACKEND_CONFIG } from "../../../config/consts";

type PaymentMethodProps = {
  carrierId: number;
  carrierName: string;
  paymentMethod: string;
  error: boolean;
  onChange: (plan: string) => void;
};

type PaymentMethodOption = {
  Name: string;
  Value: string;
};

export function PaymentMethod({ carrierId, paymentMethod, error, onChange }: PaymentMethodProps) {
  const [paymentMethods, setMethods] = useState([] as PaymentMethodOption[]);

  useEffect(() => {
    axios
      .get(BACKEND_CONFIG.apiUrl + "listitems/paymentmethods")
      .then((response) => {
        setMethods(response.data);
      });
  }, []);

  const libertyWithCreditCard = carrierId === 121  && paymentMethod === "Credit / Debit Card";

  return (
    <div className="form-group" style={{ width: "auto" }}>
      <label>Payment Method:</label>
      <div className="x-horizontal x-align-middle-left x-spacing-12px">
        <select defaultValue="" style={{ width: 280 }} onChange={(e) => onChange(e.target.value)}>
          <option value="" className="default-option" disabled>
            Select Payment Method
          </option>
          {paymentMethods.map((plan) => (
            <option value={plan.Value} key={plan.Value}>
              {plan.Name}
            </option>
          ))}
        </select>
        {libertyWithCreditCard && (
          <div style={{ color: "#ff0000" }}>
            Customer credit card payments will incur a 2.5% fee
          </div>
        )}
      </div>
      {error && <div className="error">Please select Payment Method</div>}
    </div>
  );
}
